import { XCircle } from 'lucide-react'
import CheckoutLayout from '@/frontend/layouts/CheckoutLayout'
import { Card, CardContent } from '@/components/ui/card'

export default function PaymentLinkCancel() {
  return (
    <CheckoutLayout>
      <div className="min-h-screen flex items-center justify-center px-4 py-28">
        <div className="w-full max-w-xl text-center">
          <div className="mb-6 flex justify-center">
            <XCircle className="h-16 w-16 text-rose-300" />
          </div>

          <h1 className="text-3xl font-bold text-white">Checkout cancelado</h1>
          <p className="mt-3 text-base text-slate-300">
            Nenhuma cobrança foi concluída. Para retomar a assinatura, use o link enviado pela equipe da Station Zero.
          </p>

          <Card className="mt-8 border-slate-700 bg-slate-900/70">
            <CardContent className="p-5 text-sm text-slate-300">
              Se o link expirou ou não abriu corretamente, peça um novo link de pagamento ao seu contato.
            </CardContent>
          </Card>
        </div>
      </div>
    </CheckoutLayout>
  )
}
